import PickReminderSelector from '../Football/PickReminderSelector'
import * as styles from '../Eliminator/EliminatorIntro.scss'
import terminatorErrorMessage from './terminatorErrorMessage'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Alert } from 'react-bootstrap'
import { saveReminderPreferences, getMainPageData } from '@severed-links/common.redherrings-reducers/terminator'
const TerminatorReminders = ({ data }) => {
  const dispatch = useDispatch()
  const [preferences, setPreferences] = useState(data.reminderPreferences || {})
  const [busy, setBusy] = useState(false)
  const [message, setMessage] = useState('')
  useEffect(() => setPreferences(data.reminderPreferences || {}), [data.reminderPreferences, data.config.seasonId])
  const save = async next => {
    if (busy) return
    setBusy(true)
    try {
      const action = await dispatch(saveReminderPreferences({ seasonId: data.config.seasonId, ...next }))
      if (action.error || action.payload?.messageType === 'error') throw new Error(action.payload?.response?.message || action.payload?.message || 'Unable to save reminders.')
      setPreferences(next)
      setMessage(action.payload.message)
      dispatch(getMainPageData())
    } catch (error) { setMessage(terminatorErrorMessage(error)) }
    setBusy(false)
  }
  return <div className={styles.remindersContainer}><Alert variant='info'>
    <Alert.Heading>Pick Reminders</Alert.Heading>
    <p>Indicate below whether we should send you a reminder about your pick in the hour or so before your picks are due.</p>
    <fieldset disabled={busy}><PickReminderSelector {...preferences} onChange={save} /></fieldset>
    {busy ? <p role='status'>Saving reminders…</p> : message ? <p role='status'>{message}</p> : null}
  </Alert></div>
}
export default TerminatorReminders
